import React from "react";
import { useState } from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [spellChecked, setSpellChecked] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
    setTimeout(() => setShowModal(false), 4000);
  };

  return (
    <>
      <Helmet>
        <title>Halecor - Μουσική Σχολή</title>
        <meta
          name="description"
          content="Halecor - Μουσική Σχολή - Ανακαλύψτε τον κόσμο της μουσικής με επαγγελματικούς εκπαιδευτές και σύγχρονες μεθόδους διδασκαλίας"
        />
      </Helmet>

      <div className="contact-page">
        <div className="contact-hero">
          <h1>Επικοινωνήστε μαζί μας</h1>
          <p>Είμαστε εδώ για να απαντήσουμε στις ερωτήσεις σας</p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <h2>Στοιχεία Επικοινωνίας</h2>

            <div className="contact-item">
              <FaHome className="contact-icon" />
              <div className="contact-details">
                <h3>Διεύθυνση</h3>
                <p>Pesonton Machiton 8</p>
                <p>Orchomenos 323 00, Ελλάδα</p>
              </div>
            </div>

            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="contact-details">
                <h3>Τηλέφωνο</h3>
                <p>+302261032560</p>
              </div>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-details">
                <h3>Email</h3>
                <p>
                  <a href="mailto:halecor@hotmail.com">halecor@hotmail.com</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <FaHome className="contact-icon" />
              <div className="contact-details">
                <h3>Αριθμός Μητρώου</h3>
                <p>10349910</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <h2>Στείλτε μας Μήνυμα</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">Όνομα *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Επώνυμο *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  pattern="^\+?[0-9\s\-]{7,20}$"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Αποστολή Μηνύματος
              </button>
            </form>
          </div>
        </div>

        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Ευχαριστούμε!</h3>
              <p>
                Το μήνυμά σας στάλθηκε με επιτυχία. Θα επικοινωνήσουμε μαζί σας
                το συντομότερο δυνατό.
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Contact;
